export const MEDIA_PERMISSION_ERRORS = [
  'NotAllowedError',
  'PermissionDeniedError',
  'PermissionDismissedError',
  'MediaDeviceKillSwitchOn',
]

export const MEDIA_IN_USE_ERRORS = [
  'AbortError',
  'TrackStartError',
  'NotReadableError',
  'MediaDeviceFailedDueToShutdown',
  'InvalidStateError',
]

export const MEDIA_DEVICE_MISSING_ERRORS = [
  'NotFoundError',
  'DevicesNotFoundError',
]
